<template>
    <ui-modal title="Copy estimate to..." :close="close">
        <ui-form-section class="mt-6">
            <ui-toggle
                label="Copy to another package"
                text="Do you want to copy this estimate to another package?"
                name="copy_to_other_package"
                v-model="form.copy_to_other_package">
            </ui-toggle>
            <ui-select-searchable
                v-if="form.copy_to_other_package"
                label="Package"
                placeholder="Which package would you like to copy this estimate to?"
                v-model="form.package"
                :error="form.errors.get('package_id')"
                :search="searchPackages"
                no-search="Start typing to find packages..."
            ></ui-select-searchable>
        </ui-form-section>

        <template #footer-primary>
            <ui-button-new primary class="w-full" :loading="form.busy" @click="form.submit()">
                {{ form.copy_to_other_package ? 'Copy to another package' : 'Copy to this package' }}
            </ui-button-new>
        </template>
    </ui-modal>
</template>

<script>
import { estimateStore } from '@stores'
import { Package } from '@models'

export default {
    props: {
        close: Function,
    },
    data () {
        return {
            form: new Form({ copy_to_other_package: false, package: null }, async (form) => {
                const packageId = form.copy_to_other_package ? form.package?.id : null

                if (form.copy_to_other_package && ! packageId) {
                    form.errors.errors.package_id = 'The package field is required.'
                    return
                }

                const newEstimate = await this.estimate.duplicate(packageId)
                window.location.href = newEstimate._links.show;
                this.close()
            })
        }
    },
    computed: {
        $store () {
            return estimateStore
        },
        estimate () {
            return this.$store.state.estimate
        },
    },
    methods: {
        async searchPackages (query) {
            return await Package.search(query, true)
        },
    },
}
</script>
